import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pattern-library/buttons';
import { ModalReact } from '@pattern-library/modal';
import googleAnalyticsAction from '../../assets/js/analytics.js';
import Card from '@pattern-library/card';

const propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    acceptedTerms: PropTypes.bool,
    validationError: PropTypes.string
};

function TermsAndConditionsContainer(props) {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    const convertPhone = phone => {
        return phone.replace(phoneRegex, '$1-$2-$3');
    };

    const terms = (
        <div>
            <p>
                These terms and conditions govern your express consent to receive certain
                plan-related documents, notices, and communications, including savings and
                retirement education (the &quot;documents&quot;) electronically. Electronic delivery
                (&quot;eDelivery&quot;) may include email, text message, and other electronic media
                or methods, including your retirement account website. This includes, but is not
                limited to, confirmations, quarterly or year-end account statements, regulatory
                notices and disclosures required by the Internal Revenue Service (IRS) or Department
                of Labor (DOL), and tax forms. If you do not consent to electronic delivery of tax
                forms, a paper copy will be provided. You agree that electronic delivery of these
                documents will constitute good faith compliance with the requirements to provide you
                with these documents regardless of whether you access your documents electronically.
                If the documents are provided on the employee website, they may not be available
                indefinitely. Certain documents are not required to be available on the employee
                website for more than one year, or, if later, after they are superseded by a
                subsequent version of the document. Please save the documents to your computer or
                print them and retain copies for your records. We may at our discretion provide the
                documents in paper form via U.S. mail. eDelivery may not be available for all
                communications.
            </p>
            <p>
                To access to the documents, you will need internet access and a Portable Document
                Format (PDF) reader to view, access, and save or print your documents.
            </p>
            <p>
                At any time, you may request a free paper copy of the documents or revoke your
                consent to eDelivery. To do so, go to the My Profile page of the employee website
                and select your preferred method of receiving your documents, or contact Participant
                Services at <span className="no-break">{convertPhone(props.phoneNumber)}</span>.
            </p>
            <p>
                In order to receive timely notices concerning any of the above-mentioned documents,
                you are responsible for maintaining a valid email address in the My Profile section
                of the employee website. You agree to access and check your account periodically.
                Emails returned as undeliverable may result in suspension of electronic delivery of
                the documents. In the event of suspension, paper copies of the documents may be sent
                to you through U.S. mail at the last address you have provided. It is your
                responsibility to provide us with an updated mailing address.
            </p>
            <p>
                Your consent confirms that you have a valid email address and that you have access
                to a device with internet access capable of accessing the documents using the
                hardware and software requirements described above. Your consent will remain
                effective until you revoke or change your eDelivery preferences on the employee
                website.
            </p>
        </div>
    );

    useEffect(() => {
        var termsBox = document.getElementById('terms-box');
        var scrollIndicator = document.getElementById('scroll-to-accept');
        if (termsBox) {
            termsBox.addEventListener('scroll', () => {
                let distance = termsBox.scrollTop + termsBox.clientHeight;
                let percentScrolled = Number(distance) / termsBox.scrollHeight;
                if (percentScrolled > 0.99 || acceptedTerms) {
                    scrollIndicator.style.display = 'none';
                } else {
                    scrollIndicator.style.display = 'inherit';
                }
            });
        }

        if (props.validationError) {
            scollTermsToBottom();
            var fieldset = document.getElementById('terms-checkbox');
            fieldset.classList.add('is-warning');
        }

        var checkbox = document.getElementById('checkbox-agree');
        if (checkbox) {
            checkbox.checked = props.acceptedTerms;
        }
    });

    const scollTermsToBottom = () => {
        var termsBox = document.getElementById('terms-box');
        termsBox.scrollTop = termsBox.scrollHeight;
    };

    const eDeliveryTermsChecked = () => {
        googleAnalyticsAction('eDeliveryTermsAgree');
    };

    let { acceptedTerms, validationError } = props;
    const [modalActive, setModalActive] = useState(false);
    const triggerButtonRef = React.createRef();

    return (
        <div>
            {acceptedTerms && (
                <div>
                    <input type="hidden" name="AcceptedTerms" value="true" />
                    <Button
                        className="asc-btn--link terms"
                        clickHandler={() => setModalActive(true)}
                        text="Electronic Delivery Terms and Conditions"
                        buttonRef={triggerButtonRef}
                    />
                    <ModalReact
                        headerText={'Electronic Delivery Terms and Conditions'}
                        id="terms-modal"
                        isActive={modalActive}
                        footerChildren={false}
                        closeModal={() => setModalActive(false)}
                        modalAttrs={{
                            'data-qa': 'terms-modal'
                        }}
                        hasFooter
                        hasFooterClose
                        closeOnMaskClick
                        footerCloseButtonText={'Close'}
                        triggerButtonRef={triggerButtonRef}
                    >
                        {terms}
                    </ModalReact>
                </div>
            )}
            {!acceptedTerms && (
                <Card className="asc-p-2" border padding={false}>
                    <div id="terms-box" className="asc-tc-scroll-content">
                        <h4>Electronic Delivery Terms and Conditions</h4>
                        {terms}
                        <Card className="asc-p-2" border padding={false} backgroundColor={'gray-1'}>
                            <fieldset id="terms-checkbox">
                                <div className="asc-checkbox-group">
                                    <input
                                        id="checkbox-agree"
                                        type="checkbox"
                                        name="AcceptedTerms"
                                        value="true"
                                        onClick={eDeliveryTermsChecked}
                                    />
                                    <label className="asc-form-label" htmlFor="checkbox-agree">
                                        I Agree to Terms and Conditions
                                    </label>
                                    {typeof validationError !== 'undefined' && (
                                        <p className="asc-form-help">{validationError}</p>
                                    )}
                                </div>
                            </fieldset>
                        </Card>
                    </div>
                    <span
                        id="scroll-to-accept"
                        className="asc-tc-scroll-indicator"
                        aria-hidden="true"
                    >
                        Scroll to Accept
                        <span className="asc-icon asc-icon--arrow-down" />
                    </span>
                </Card>
            )}
        </div>
    );
}

TermsAndConditionsContainer.propTypes = propTypes;
export default TermsAndConditionsContainer;
